import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export interface ErrorDialogData {
    title: string;
    message: string;
    contactInfo?: {
        companyName: string;
        email: string;
        phone: string;
        phoneOption?: string;
    };
}

@Component({
    selector: 'app-error-dialog',
    template: require('./error-dialog.component.html')
})
export class ErrorDialogComponent {
    constructor(
        @Inject(MatDialogRef<ErrorDialogComponent>) public dialogRef: MatDialogRef<ErrorDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ErrorDialogData
    ) {}

    closeDialog() {
        this.dialogRef.close();
    }
}
